module.exports = __webpack_public_path__ + "images/apple-touch-icon-80738d.png";